import React from 'react';
import HtmlPreview from '../HtmlPreview.tsx';

const HtmlPreviewWrapper = ({ htmlContent, templateName }: { htmlContent: string; templateName: string }) => {
  // Provide a location override so HtmlPreview can read the data from location.state
  const locationOverride = { state: { name: templateName, report: htmlContent } };
  return <HtmlPreview locationOverride={locationOverride} />;
};

export default HtmlPreviewWrapper;
